require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./container"), require("./label"), require("./list"), require("./radiogroup"), require("./vspacer"), require("./separator"), require("./checkboxgroup"), require("./toggleswitchgroup"), require("./accordion"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./container", "./label", "./list", "./radiogroup", "./vspacer", "./separator", "./checkboxgroup", "./toggleswitchgroup", "./accordion"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./container"), require("./label"), require("./list"), require("./radiogroup"), require("./vspacer"), require("./separator"), require("./checkboxgroup"), require("./toggleswitchgroup"), require("./accordion")) : factory(root["./utils"], root["./container"], root["./label"], root["./list"], root["./radiogroup"], root["./vspacer"], root["./separator"], root["./checkboxgroup"], root["./toggleswitchgroup"], root["./accordion"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__19__, __WEBPACK_EXTERNAL_MODULE__25__, __WEBPACK_EXTERNAL_MODULE__43__, __WEBPACK_EXTERNAL_MODULE__44__, __WEBPACK_EXTERNAL_MODULE__45__, __WEBPACK_EXTERNAL_MODULE__68__, __WEBPACK_EXTERNAL_MODULE__69__, __WEBPACK_EXTERNAL_MODULE__70__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[37],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__19__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(339);


/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Menu = _interopRequireDefault(__webpack_require__(340));

exports["default"] = _Menu["default"];
exports.Menu = _Menu["default"];

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _list = _interopRequireDefault(__webpack_require__(25));

var _utils = __webpack_require__(4);

var _radiogroup = _interopRequireDefault(__webpack_require__(43));

var _checkboxgroup = _interopRequireDefault(__webpack_require__(68));

var _toggleswitchgroup = __webpack_require__(69);

var _label = _interopRequireDefault(__webpack_require__(19));

var _accordion = _interopRequireWildcard(__webpack_require__(70));

var _vspacer = _interopRequireDefault(__webpack_require__(44));

var _separator = _interopRequireDefault(__webpack_require__(45));

var _container = _interopRequireDefault(__webpack_require__(18));

var _Menu = _interopRequireDefault(__webpack_require__(341));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var MenuClassName = _Menu["default"].menuClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;

function isPropsValid(props) {
  if (!props.name) {
    console.error('A name property must be specified for each Menu Section.'); // eslint-disable-line no-console
  }
}

function getGroupedSection(sectionContent, label, accordion, type) {
  var list = type.list,
      radio = type.radio,
      checkbox = type.checkbox,
      toggleswitch = type.toggleswitch;
  return /*#__PURE__*/_react["default"].createElement("div", null, accordion ? /*#__PURE__*/_react["default"].createElement("div", null, sectionContent) : /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _utils.classnames)(MenuClassName + "__grouped-section", {
      list: list,
      radio: radio,
      checkbox: checkbox,
      toggleswitch: toggleswitch
    })
  }, label && /*#__PURE__*/_react["default"].createElement(_label["default"], {
    type: "caption",
    label: label
  }), sectionContent));
}

function _isSelected(itemProps, index) {
  var selected = itemProps.selected,
      name = itemProps.name,
      content = itemProps.content;
  return selected[name] === content[index].value;
}

function onChangeList(itemProps, event) {
  var content = itemProps.content,
      onChange = itemProps.onChange,
      selected = itemProps.selected,
      name = itemProps.name;

  var index = _utils.listHelper.singleSelect(event, content, selected[name]);

  var item = content[index];
  onChange && onChange(name, item.value, event.disabled);
}

function onChangeCheckboxOrToggle(content, label, name, checkboxSelected, onChange) {
  var selectedIndex = content.map(function (item) {
    return item.label;
  }).indexOf(label);
  var valueToChange = content[selectedIndex].value;
  checkboxSelected[valueToChange] = !checkboxSelected[valueToChange];
  onChange && onChange(name, checkboxSelected);
}

var Menu = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Menu, _Component);

  function Menu(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_containerRef", function (node) {
      _this._container = node;
    });
    _this.state = {
      top: 0,
      left: 0
    };
    return _this;
  }

  var _proto = Menu.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this._container) this._getPosition();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If now there is positioning and previously there wasn't
    if (this.props.position && !prevProps.position) {
      this._getPosition(); // Or if there is positioning, and previously there was, check if that positioning has changed and if so update the position

    } else if (this.props.position) {
      if (prevProps.position.x !== this.props.position.x || prevProps.position.y !== this.props.position.y || prevProps.width !== this.props.width) {
        this._getPosition();
      }
    }
  } // This is being done this way to mimic the behaviour of context menus in Glass
  ;

  _proto._getPosition = function _getPosition() {
    var position = this.props.position;

    var containerRect = this._container._node.getBoundingClientRect();

    var width = containerRect.width + 3;
    var height = containerRect.height + 3;
    var left;

    if (window.innerWidth - position.x < width) {
      left = window.innerWidth - width;
    } else {
      left = position.x;
    }

    var top;

    if (window.innerHeight - position.y < height) {
      top = window.innerHeight - height;
    } else {
      top = position.y;
    }

    this.setState({
      top: top,
      left: left
    });
  };

  Menu.Separator = function Separator(props) {
    return /*#__PURE__*/_react["default"].createElement(_separator["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-menu__separator"
    }, props));
  };

  Menu.Spacer = function Spacer(props) {
    return /*#__PURE__*/_react["default"].createElement(_vspacer["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-menu__spacer"
    }, props));
  };

  Menu.Accordion = function Accordion(props) {
    var onChange = props.onChange,
        selected = props.selected,
        children = props.children,
        passThrough = (0, _objectWithoutPropertiesLoose2["default"])(props, ["onChange", "selected", "children"]);
    return /*#__PURE__*/_react["default"].createElement(_accordion["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-menu__accordion"
    }, passThrough, {
      className: MenuClassName + "__grouped-section"
    }), _react.Children.map(children, function (child) {
      return /*#__PURE__*/_react["default"].createElement(_accordion.AccordionItem, {
        "data-tid": "ba-common-menu__accordion-item-" + child.props.name,
        id: "ba-accordion-item-1-" + child.props.name,
        itemName: child.props.label,
        icon: "left"
      }, (0, _react.cloneElement)(child, {
        onChange: onChange,
        selected: selected,
        accordion: true
      }));
    }));
  };

  Menu.List = function List(props) {
    isPropsValid(props);
    var content = props.content,
        accordion = props.accordion,
        label = props.label,
        onChange = props.onChange,
        name = props.name,
        selected = props.selected,
        clickSelection = props.clickSelection,
        passThrough = (0, _objectWithoutPropertiesLoose2["default"])(props, ["content", "accordion", "label", "onChange", "name", "selected", "clickSelection"]);
    var listProps = (0, _extends2["default"])({
      'data-tid': 'ba-common-menu__list'
    }, passThrough, {
      options: content,
      isSelected: function isSelected(index) {
        return _isSelected({
          content: content,
          onChange: onChange,
          selected: selected,
          name: name
        }, index);
      },
      onSelectionChange: function onSelectionChange(event) {
        return onChangeList(props, event);
      },
      length: content.length,
      initialIndex: 0,
      selectionMode: 'single',
      tabIndex: 0,
      clickSelection: clickSelection
    });

    var sectionContent = /*#__PURE__*/_react["default"].createElement(_list["default"], listProps);

    return getGroupedSection(sectionContent, label, accordion, {
      list: true
    });
  };

  Menu.Radio = function Radio(props) {
    isPropsValid(props);
    var content = props.content,
        accordion = props.accordion,
        label = props.label,
        _onChange = props.onChange,
        selected = props.selected,
        name = props.name,
        passThrough = (0, _objectWithoutPropertiesLoose2["default"])(props, ["content", "accordion", "label", "onChange", "selected", "name"]);
    var radioProps = (0, _extends2["default"])({
      'data-tid': 'ba-common-menu__radios'
    }, passThrough, {
      options: content,
      direction: 'vertical',
      checked: selected[name],
      onChange: function onChange(value) {
        return _onChange(name, value);
      }
    });

    var sectionContent = /*#__PURE__*/_react["default"].createElement(_radiogroup["default"], radioProps);

    return getGroupedSection(sectionContent, label, accordion, {
      radio: true
    });
  };

  Menu.Checkbox = function Checkbox(props) {
    isPropsValid(props);
    var content = props.content,
        accordion = props.accordion,
        label = props.label,
        _onChange2 = props.onChange,
        selected = props.selected,
        name = props.name,
        passThrough = (0, _objectWithoutPropertiesLoose2["default"])(props, ["content", "accordion", "label", "onChange", "selected", "name"]);
    var checkboxSelected = selected[name] ? (0, _extends2["default"])({}, selected[name]) : {}; // Conversion for object value being set to true to label being set to true for checkboxgroup

    var parsedCheckboxSelected = {};

    for (var i = 0; i < content.length; i++) {
      if (checkboxSelected[content[i].value]) parsedCheckboxSelected[content[i].label] = true;
    }

    var checkboxProps = (0, _extends2["default"])({
      'data-tid': 'ba-common-menu__checkboxes'
    }, passThrough, {
      options: content,
      direction: 'vertical',
      selected: parsedCheckboxSelected,
      onChange: function onChange(value) {
        return onChangeCheckboxOrToggle(content, value, name, checkboxSelected, _onChange2);
      }
    });

    var sectionContent = /*#__PURE__*/_react["default"].createElement(_checkboxgroup["default"], checkboxProps);

    return getGroupedSection(sectionContent, label, accordion, {
      checkbox: true
    });
  };

  Menu.ToggleSwitch = function ToggleSwitch(props) {
    isPropsValid(props);
    var content = props.content,
        accordion = props.accordion,
        label = props.label,
        _onChange3 = props.onChange,
        selected = props.selected,
        name = props.name,
        passThrough = (0, _objectWithoutPropertiesLoose2["default"])(props, ["content", "accordion", "label", "onChange", "selected", "name"]);
    var ToggleSwitchSelected = selected[name] ? (0, _extends2["default"])({}, selected[name]) : {};
    var parsedToggleSwitchSelected = {};

    for (var i = 0; i < content.length; i++) {
      if (ToggleSwitchSelected[content[i].value]) {
        parsedToggleSwitchSelected[content[i].label] = true;
      }
    }

    var toggleswitchprops = (0, _extends2["default"])({
      'data-tid': 'ba-common-menu__toggleswitches'
    }, passThrough, {
      options: content,
      direction: 'vertical',
      selected: parsedToggleSwitchSelected,
      small: true,
      onChange: function onChange(value) {
        return onChangeCheckboxOrToggle(content, value, name, ToggleSwitchSelected, _onChange3);
      }
    });

    var sectionContent = /*#__PURE__*/_react["default"].createElement(_toggleswitchgroup.ToggleSwitchGroup, toggleswitchprops);

    return getGroupedSection(sectionContent, label, accordion, {
      toggleswitch: true
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        onChange = _this$props.onChange,
        selected = _this$props.selected,
        position = _this$props.position,
        width = _this$props.width,
        height = _this$props.height,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["children", "onChange", "selected", "position", "width", "height", "className", "style"]);
    var _this$state = this.state,
        top = _this$state.top,
        left = _this$state.left;
    var classNames = (0, _utils.classnames)(MenuClassName);
    var contentWidth = position ? '100%' : width;
    var contentHeight = position ? '100%' : height;

    var content = /*#__PURE__*/_react["default"].createElement("div", {
      className: classNames + " " + className,
      style: {
        width: contentWidth,
        height: contentHeight
      }
    }, _react.Children.map(children, function (child) {
      return child && (0, _react.cloneElement)(child, {
        onChange: onChange,
        selected: selected
      });
    }));

    var styles = (0, _extends2["default"])({
      position: 'fixed',
      top: top + "px",
      left: left + "px"
    }, style);
    return position ? /*#__PURE__*/_react["default"].createElement(_container["default"], (0, _extends2["default"])({}, sanitize(others, Menu), {
      className: MenuClassName + "__container " + className,
      width: width,
      gutter: [0, 0],
      height: height,
      style: styles,
      ref: this._containerRef
    }), content) : content;
  };

  return Menu;
}(_react.Component);

exports["default"] = Menu;
(0, _defineProperty2["default"])(Menu, "propTypes", {
  /** Sub-components of Menu to display (i.e. Menu.List, Menu.Radio, etc.) */
  children: _propTypes["default"].node,

  /** Function that is called when a value in the Menu changes (name and value are arguments) */
  onChange: _propTypes["default"].func,

  /** Object that defines which items from each sub-component are selected */
  selected: _propTypes["default"].object,

  /** Defines the position of where the menu should be fixed on the screen */
  position: _propTypes["default"].shape({
    x: _propTypes["default"].number.isRequired,
    y: _propTypes["default"].number.isRequired
  }),

  /** The width of the menu */
  width: _propTypes["default"].string,

  /** The height of the menu */
  height: _propTypes["default"].string,

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Custom CSS styling */
  style: _propTypes["default"].object
});
(0, _defineProperty2["default"])(Menu, "defaultProps", {
  selected: {},
  className: '',
  style: {}
});

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(342);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".is-contextMenu{background-color:#fff}.ba-common-menu .ba-radioGroup,.ba-common-menu .ba-checkboxGroup,.ba-common-menu .ba-toggleswitchGroup,.ba-common-menu .ba-common-list{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px}.ba-common-menu .ba-common-label{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px}.ba-common-menu__grouped-section{padding:0;width:100%;min-width:104px}.ba-common-menu__grouped-section.is-radio,.ba-common-menu__grouped-section.is-checkbox,.ba-common-menu__grouped-section.is-toggleswitch{padding:1rem}.ba-common-menu__grouped-section.is-list .ba-common-label{padding-top:1rem}.ba-common-menu .ba-common-menu__icon{display:flex}.ba-common-menu .ba-common-menu__item{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;height:40px;display:flex;align-items:center;cursor:pointer;border-left-width:4px}.ba-common-menu .ba-common-menu__item .ba-common-toolTip{width:100%}.ba-common-menu .ba-common-menu__item--text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ba-common-menu .ba-common-menu__item.is-disabled{cursor:not-allowed}.ba-common-menu .ba-common-menu__item.is-disabled--text .cursor{cursor:not-allowed}.ba-common-menu:not(.is-contextMenu){background-color:#fff}.ba-common-menu__container{min-width:200px;box-shadow:0 2px 6px 0 rgba(0,0,0,0.3);border:#a8c0f3;z-index:top-front-layer}[dir=\"ltr\"] .ba-common-menu__grouped-section.is-list .ba-common-label,.ba-common-menu__grouped-section.is-list .ba-common-label{padding-left:1rem}[dir=\"ltr\"] .ba-common-menu .ba-common-menu__icon,.ba-common-menu .ba-common-menu__icon{margin-right:8px}[dir=\"rtl\"] .ba-common-menu__grouped-section.is-list .ba-common-label{padding-left:unset;padding-right:1rem}[dir=\"rtl\"] .ba-common-menu .ba-common-menu__icon{margin-right:unset;margin-left:8px}\n", ""]);

// exports
exports.locals = {
	"menuClassName": "\"ba-common-menu\""
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__43__;

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__44__;

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__45__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__68__;

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__69__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__70__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[338,0]]]);
});